// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  orderId: __t.u64().primaryKey().name("order_id"),
  owner: __t.identity(),
  stationKey: __t.string().name("station_key"),
  side: __t.string(),
  familyKey: __t.string().name("family_key"),
  priceSov: __t.i64().name("price_sov"),
  qty: __t.u32(),
  placedAt: __t.timestamp().name("placed_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
